// @flow

import classNames from 'classnames';
import React from 'react';
import type { Node } from 'react';

import {
  reviewsLogoCls,
  reviewsLogoHorizontalCls,
  reviewsLogoVerticalCls,
  reviewsLogoIconCls,
  reviewsLogoStarsCls,
} from 'shared_components/arts/reviews/Logo.less';

import reviewsLogo from 'shared_components/arts/reviews/images/reviewsio-logo.png';
import reviewsStars from 'shared_components/arts/reviews/images/reviewsio-stars.png';

type Props = {
  align?: 'horizontal' | 'vertical',
};

/**
 * ReviewsLogo
 *
 * @params {Props} props
 * @returns {Node}
 */
export function ReviewsLogo({ align = 'horizontal' }: Props): Node {
  return (
    <div
      className={classNames(
        reviewsLogoCls,
        align === 'vertical' ? reviewsLogoVerticalCls : reviewsLogoHorizontalCls,
      )}
    >
      <div className={reviewsLogoStarsCls}>
        <img src={reviewsStars} alt="" />
      </div>
      <div className={reviewsLogoIconCls}>
        <img src={reviewsLogo} alt="" />
      </div>
    </div>
  );
}
